// import React, { useEffect, useState, useRef, useCallback } from "react";
// import { FaBell } from "react-icons/fa";
// import notificationSocketManager from "../socket/NotificationSocketManager";
// import "./NotificationDropdown.css";
// import config from "../config/config";
// import { formatDateForQuery } from "../utils/utils";
// import { userSession } from "../observers/userObserver";

// const NotificationDropdown = () => {
//   const [notifications, setNotifications] = useState([]);
//   const [open, setOpen] = useState(false);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const [unreadCount, setUnreadCount] = useState(0);
//   const dropdownRef = useRef(null);
//   const contentRef = useRef(null);

//   const fetchNotifications = useCallback(async (pageNum) => {

//     if (!userSession.getToken()) return;

//     if (loading || !hasMore) return;

//     setLoading(true);
//     try {
//       const response = await fetch(`${config["backend-url"]}/notifications?page=${pageNum}&limit=5`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${userSession.getToken()}`,
//         },
//       });
//       const data = await response.json();
//       const newData = data.notifications.data || [];
//       const unreadCount = data.total_unread || 0;

//       setUnreadCount(unreadCount);

//       if (pageNum === 1) {
//         setNotifications(newData);
//       } else {
//         setNotifications((prev) => [...prev, ...newData]);
//       }

//       setHasMore(newData.length > 0);
//       setPage(pageNum);
//     } catch (error) {
//       console.error("Error fetching notifications:", error);
//     }
//     setLoading(false);
//   }, [loading, hasMore]);

//   useEffect(()=>{

//   })

//   const handleScroll = () => {
//     if (
//       contentRef.current &&
//       contentRef.current.scrollTop + contentRef.current.clientHeight >= contentRef.current.scrollHeight - 10
//     ) {
//       fetchNotifications(page + 1);
//     }
//   };

//   const handleSocketConnection = (token) => {
//     notificationSocketManager.disconnect();
//     notificationSocketManager.connect(token, (socket) => {
//       notificationSocketManager.on("new_notification", (data) => {
//         setNotifications((prev) => [data, ...prev]);
//         setUnreadCount((prev) => prev + 1);
//       });
//     });
//   }

//   useEffect(() => {

//     userSession.subscribe((user, token)=>{
//       handleSocketConnection(token);
//       fetchNotifications(1);
//     });


//     const handleOutsideClick = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleOutsideClick);
//     return () => document.removeEventListener("mousedown", handleOutsideClick);
//   }, []);

//   const toggleDropdown = () => setOpen(!open);

//   const markAllAsRead = async () => {

//     const notification_ids = notifications.map((n) => n.notification_id);

//     try {
//       await fetch(`${config["backend-url"]}/notifications`, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${userSession.getToken()}`,
//         },
//         body: JSON.stringify({ notification_ids }),
//       });
//       fetchNotifications(1);
//     } catch (error) {
//       console.error("Failed to mark notifications as read:", error);
//     }
//   };

//   return (
//     <div className="notification-container" ref={dropdownRef}>
//       <div className="notification-icon" onClick={toggleDropdown}>
//         <FaBell />
//         {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
//       </div>
//       {open && (
//         <div className="notification-dropdown">
//           <div className="notification-header">
//             <span>Notifications</span>
//             <span className="mark-read" onClick={markAllAsRead}>
//               Mark all as read
//             </span>
//           </div>
//           <div
//             className="notification-content"
//             ref={contentRef}
//             onScroll={handleScroll}
//           >
//             {notifications.length === 0 ? (
//               <div className="notification-empty">No notifications</div>
//             ) : (
//               notifications.map((notif, index) => (
//                 <div key={index} className={`notification-item ${notif.is_read ? '' : 'unread'}`}>
//                   <div className="notification-message">{notif.message}</div>
//                   <div className="notification-time">
//                     {formatDateForQuery(notif.created_at)}
//                   </div>
//                 </div>
//               ))
//             )}
//             {loading && <div className="notification-loading">Loading...</div>}
//             {!hasMore && <div className="notification-end">No more notifications</div>}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default NotificationDropdown;



import React, { useEffect, useState, useRef, useCallback } from "react";
import { FaBell } from "react-icons/fa";
import notificationSocketManager from "../socket/NotificationSocketManager";
import "./NotificationDropdown.css";
import config from "../config/config";
import { formatDateForQuery } from "../utils/utils";
import { userSession } from "../observers/userObserver";
import { useNavigate } from "react-router-dom"; // ⬅️ Add this import
import { sharedData } from "../sharedData/sharedData";
const NotificationDropdown = () => {
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const dropdownRef = useRef(null);
  const contentRef = useRef(null);
  const navigate = useNavigate(); // ⬅️ Initialize navigate

  const fetchNotifications = useCallback(async (pageNum) => {
    if (!userSession.getToken()) return;
    if (loading || !hasMore) return;

    setLoading(true);
    try {
      const response = await fetch(`${config["backend-url"]}/notifications?page=${pageNum}&limit=5`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userSession.getToken()}`,
        },
      });
      const data = await response.json();
      const newData = data.notifications.data || [];
      const unreadCount = data.total_unread || 0;

      setUnreadCount(unreadCount);

      if (pageNum === 1) {
        setNotifications(newData);
      } else {
        setNotifications((prev) => [...prev, ...newData]);
      }

      setHasMore(newData.length > 0);
      setPage(pageNum);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
    setLoading(false);
  }, [loading, hasMore]);

  const handleScroll = () => {
    if (
      contentRef.current &&
      contentRef.current.scrollTop + contentRef.current.clientHeight >= contentRef.current.scrollHeight - 10
    ) {
      fetchNotifications(page + 1);
    }
  };

  const handleSocketConnection = (token) => {
    notificationSocketManager.disconnect();
    notificationSocketManager.connect(token, (socket) => {
      notificationSocketManager.on("new_notification", (data) => {
        setNotifications((prev) => [data, ...prev]);
        setUnreadCount((prev) => prev + 1);
      });
    });
  };

  useEffect(() => {
    userSession.subscribe((user, token) => {
      handleSocketConnection(token);
      fetchNotifications(1);
    });

    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const toggleDropdown = () => setOpen(!open);

  const markAllAsRead = async (notification_id) => {
    let notification_ids = [];
    if (!notification_id) 
      notification_ids = notifications.map((n) => n.notification_id);
    else 
      notification_ids = [notification_id];

    try {
      await fetch(`${config["backend-url"]}/notifications`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userSession.getToken()}`,
        },
        body: JSON.stringify({ notification_ids }),
      });
      fetchNotifications(1);
      setNotifications((prev) => {
        return prev.map((n) => {
          if (notification_ids.includes(n.notification_id)) {
            return { ...n, is_read: true };
          }
          return n;
        });
      })
    } catch (error) {
      console.error("Failed to mark notifications as read:", error);
    }
  };

  const moveToRequest = async (notification_id, requestId) => {
    markAllAsRead(notification_id);

    try {
      const response =await fetch(`${config["backend-url"]}/get_filter_request`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userSession.getToken()}`,
        },
        body: JSON.stringify({ RequestID: requestId }),
      });

      const data = await response.json();

      if (data.data.length === 0) {
        localStorage.removeItem("transaction");
        localStorage.removeItem("propertyFormData");
        localStorage.removeItem("clientFormData");
        localStorage.removeItem("corporateFormData");
        localStorage.removeItem("riskFormData");
        localStorage.removeItem("riskFormDataContinued");
        localStorage.removeItem("managers");
        sharedData.set("requestId", requestId);
        sharedData.set("transactionId", null);
        sharedData.set("entityId", null);
        sharedData.set("propertyId", null);
        sharedData.set("status", null);
        navigate("/transaction-detail?edit=true");
        return;
      }

      const ids = data.data[0];

      localStorage.removeItem("transaction");
      localStorage.removeItem("propertyFormData");
      localStorage.removeItem("clientFormData");
      localStorage.removeItem("corporateFormData");
      localStorage.removeItem("riskFormData");
      localStorage.removeItem("riskFormDataContinued");
      localStorage.removeItem("managers");
      sharedData.set("requestId", ids['request_id']);
      sharedData.set("transactionId", ids['transaction_id'] === 'N/A' ? null : ids['transaction_id']);
      sharedData.set("entityId", ids['EntityId'] === 'N/A' ? null : ids['EntityId']);
      sharedData.set("propertyId", ids['PropertyId'] === 'N/A' ? null : ids['PropertyId']);
      sharedData.set("status", ids['Request_Status'] === 'N/A' ? null : ids['Request_Status']);
      navigate("/transaction-detail?edit=true");

    } catch (error) {
      console.error("Failed to move to request:", error);
    }

    // sharedData.set("requestId", row.id);
    // sharedData.set("transactionId", row.transaction);
    // sharedData.set("entityId", row.entityId);
    // sharedData.set("propertyId", row.propertyId);
    // sharedData.set("status", row.status);
    // navigate("/transaction-detail?edit=true");

  }

  return (
    <div className="notification-container" ref={dropdownRef}>
      <div className="notification-icon" onClick={toggleDropdown}>
        <FaBell />
        {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
      </div>
      {open && (
        <div className="notification-dropdown">
          <div className="notification-header">
            <span>Notifications</span>
            <span className="mark-read" onClick={markAllAsRead}>
              Mark all as read
            </span>
          </div>
          <div className="notification-content" ref={contentRef} onScroll={handleScroll}>
            {notifications.length === 0 ? (
              <div className="notification-empty">No notifications</div>
            ) : (
              notifications.map((notif, index) => (
                <div
                  key={index}
                  className={`notification-item ${notif.is_read ? "" : "unread"}`}
                  onClick={() => { moveToRequest(notif.notification_id, notif.request_id) }}
                  style={{ cursor: "pointer" }}
                >
                  <div className="notification-message">{notif.message}</div>
                  <div className="notification-time">
                    {formatDateForQuery(notif.created_at)}
                  </div>
                </div>
              ))
            )}
            {loading && <div className="notification-loading">Loading...</div>}
            {!hasMore && <div className="notification-end">No more notifications</div>}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationDropdown;
